import { useNavigate } from "react-router-dom";
import { ClipboardList, House } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import PageHeader from "@/components/PageHeader";

export default function AtHomeMyBookings() {
  const navigate = useNavigate();
  return (
    <div className="max-w-3xl" data-testid="at-home-bookings-page">
      <PageHeader title="My At-Home Bookings" subtitle="Nursing, physio, lab tests & more" icon={ClipboardList} color="#0891B2" />
      <Card className="rounded-3xl p-8 text-center border-border">
        <House className="h-10 w-10 mx-auto text-muted-foreground" />
        <p className="mt-3 font-semibold">No at-home bookings yet</p>
        <p className="text-sm text-muted-foreground mt-1">Book a lab test, nurse, physio or teleconsult to see it here.</p>
        <div className="flex gap-2 justify-center mt-4">
          <Button className="rounded-2xl bg-[#0891B2]" onClick={() => navigate("/at-home-care/lab-tests")} data-testid="ahb-labs">Book Lab Test</Button>
          <Button variant="outline" className="rounded-2xl" onClick={() => navigate("/care-hub")} data-testid="ahb-carehub">Explore Care Hub</Button>
        </div>
      </Card>
    </div>
  );
}
